import { jsx, Fragment } from 'react/jsx-runtime';

const Wrap = ({ children, if: condition, render }) => {
    return condition ? render(children) : jsx(Fragment, { children: children });
};

export { Wrap };
//# sourceMappingURL=Wrap.js.map
